export function getJigsawUserInfo(): Promise<
  Jigsaw.JigsawResponse<Jigsaw.UserData>
> {
  return new Promise((resolve) => {
    window.Jigsaw.User.getInfo((data: Jigsaw.JigsawResponse<Jigsaw.UserData>) =>
      resolve(data)
    );
  });
}
